import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c626f928"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "theme-case-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "theme-case-head" }, [
  /*#__PURE__*/_createElementVNode("span", null, "主题方案")
], -1))
const _hoisted_3 = { class: "custom-case-list" }

import { ref, toRefs, watch } from 'vue'
import { NScrollbar } from 'naive-ui'
import usePreference from '@teams/common/hooks/usePreference'
import CustomCaseItem from './customCaseItem.vue'
import { useH5PreviewPreference } from '@/views/home/preview/hooks'

type ICaseItem = {
  key: string
  img?: string
  name: string
  official?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'themeCase',
  emits: ['handleCreateNewTheme', 'updateCurrentTheme'],
  setup(__props, { emit: emits }) {


const preference = usePreference()
const h5PreviewPreference = useH5PreviewPreference()
const { changeCurrentTheme } = preference
const { themeList, current } = toRefs(preference)
const themeItemList = ref(themeList.value)
watch(themeList, val => {
  themeItemList.value = val
})
// 新建主题
const handleCreateNewTheme = () => {
  emits('handleCreateNewTheme')
}

// 更改主题方案
const changeTheme = (item: ICaseItem) => {
  changeCurrentTheme(item.key)
  h5PreviewPreference.changeCurrentTheme(item.key)
  emits('updateCurrentTheme', item)
}

// 刷新列表
const refreThemeList = () => {
  // 替换为第一个主题
  changeCurrentTheme(preference.themeList[0]?.key || '')
  h5PreviewPreference.changeCurrentTheme(preference.themeList[0]?.key || '')
}
// 重名名更新当前选中的主题
const updateCurrentItem = (item: ICaseItem) => {
  emits('updateCurrentTheme', item)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(NScrollbar), { style: {"{\n          max-height":"100%"} }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(themeItemList.value, (item, index) => {
            return (_openBlock(), _createBlock(CustomCaseItem, {
              key: index,
              item: item,
              selectedFlag: _unref(current).theme.key === item.key ? true : false,
              onClick: ($event: any) => (changeTheme(item)),
              onHandleCreateNewTheme: handleCreateNewTheme,
              onRefreThemeList: refreThemeList,
              onUpdateCurrentItem: updateCurrentItem
            }, null, 8, ["item", "selectedFlag", "onClick"]))
          }), 128))
        ])
      ]),
      _: 1
    })
  ]))
}
}

})